import { render, staticRenderFns } from "./factor.vue?vue&type=template&id=2a889fd6&scoped=true"
import script from "./factor.vue?vue&type=script&lang=js"
export * from "./factor.vue?vue&type=script&lang=js"
import style0 from "./factor.vue?vue&type=style&index=0&id=2a889fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a889fd6",
  null
  
)

export default component.exports